import { Pipe, PipeTransform } from '@angular/core';
import { map } from 'rxjs/operators';
import { Observable } from 'rxjs';
import { UserSettingsStateService } from '../../shared/user-settings-state.service';

@Pipe({ name: 'isFavorite' })
export class IsFavoritePipe implements PipeTransform {
  constructor(private state: UserSettingsStateService) {
  }

  transform(procedureId: number): Observable<boolean> {
    return this.state.favoriteProcedures$.pipe(
      map(list => list.includes(procedureId)),
    );
  }
}
